module.exports = __webpack_public_path__ + "static/media/slider_bg_2.3bcb01e4.jpg";